import { bl_sfa_project_ext_RowClass } from "../../../dbschema/bl_sfa_project_ext.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaProjectExtContainerModel extends BaseContainerModel {
    bl_sfa_project_ext: bl_sfa_project_ext_RowClass = new bl_sfa_project_ext_RowClass();
}